var exports = {
  "kL": "VoiceMessagePlayer.module__container___U3VpUG",
  "Kd": "VoiceMessagePlayer.module__containerActive___U3VpUG",
  "hd": "VoiceMessagePlayer.module__waveformBar___U3VpUG",
  "x5": "VoiceMessagePlayer.module__waveformBarPast___U3VpUG",
  "Rr": "VoiceMessagePlayer.module__playButton___U3VpUG",
  "CJ": "VoiceMessagePlayer.module__playButtonIcon___U3VpUG",
  "S": "VoiceMessagePlayer.module__loadingSpinner___U3VpUG",
  "FU": "VoiceMessagePlayer.module__waveformContainer___U3VpUG",
  "vE": "VoiceMessagePlayer.module__timestamp___U3VpUG",
  "NS": "VoiceMessagePlayer.module__speedControl___U3VpUG",
  "Wq": "VoiceMessagePlayer.module__volumeControl___U3VpUG",
};

module.exports = exports;
